export default __webpack_public_path__ + "37ac90bead83e00f510a6f9802daac56.png";